import React from 'react';
import ENV from '../../utilities/environment';
import WikiClassTable from './WikiClassTable';
import './WikiMenu.css';

export default function WikiShoes(props) {
    const { content } = props;
    const TableItems =
        Array.isArray(content) && content.length > 0 ? (
            content.map((item) => (
                <tr>
                    <td>{item.name}</td>{' '}
                    <td>
                        <div className="content-shop-item-img">
                            <img
                                src={`${ENV.apiURL}${item?.image?.url}`}
                                alt=""
                                style={{ maxWidth: '100%' }}
                            />
                        </div>
                    </td>{' '}
                    <td>{item.damage}</td>
                    <td>{item.durability}</td>
                    <td>{item.level}</td>
                    <td>{item.energy}</td>
                </tr>
            ))
        ) : (
            <></>
        );

    return (
        <WikiClassTable title="Boots">
            <table className="table-items">
                <tr>
                    <th rowSpan="2">NAME</th>
                    <th rowSpan="2">BOOTS</th>
                </tr>
                <tr>
                    <th className="table-items-tr">DAMAGE</th>
                    <th className="table-items-tr">DURABILITY</th>
                    <th className="table-items-tr">LEVEL</th>
                    <th className="table-items-tr">ENERGY</th>
                </tr>
                {TableItems}
            </table>
        </WikiClassTable>
    );
}
